import { MAP_MARKER_SHOW_INFO, MAP_MARKER_HIDE_INFO, DATE_FILTER_SET, GROUPAGE_ASSIGNED, GROUPAGE_UNASSIGNED, GROUPAGE_ASSIGN_FAILED, GROUPAGE_CREATED, GROUPAGE_DESTROYED, RESENT_SMS, ORDER_UPDATED, ORDER_CANCELED, ORDER_LIST_VIEW_MODE_CHANGED, GROUPAGE_GPS_LOGS_FETCHED, DISTANCE_ORDER_DRIVERS } from '../constants/actionTypes';
import objectAssign from 'object-assign';
import _ from 'lodash';
import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default function dashboardPageReducer(state = initialState.dashboardState, action) {
  let newSetOfItemIdsWithShowInfo;
  let drivers = [];

  switch (action.type) {

    case types.LOCAL_DRIVER_UPDATED: {
      drivers = objectAssign([], state.drivers);
      let dr = drivers.find((driver) => driver.id === action.driver.id);
      if(dr)
        objectAssign(drivers.find((driver) => driver.id === action.driver.id), action.driver);
      return objectAssign({}, state, { drivers: drivers, loaded: true });
    }      

    case types.showOrderOption_changed:
      return objectAssign({}, state, { showOrderOption: action.showOrderOption });

    case types.TEAMS_FOR_DASH_FETCHED: {
      let teams = [];
      let drivers = [];
      let driversLocations = [];
      _.map(action.teams, (team) => {
        if(team.drivers) {
          drivers = drivers.concat(team.drivers);
          _.map(team.drivers, (driver) => {
            if(driver.driverGpsLocations) {
              driversLocations.push(driver.driverGpsLocations);
            }
            delete driver.driverGpsLocations;
          });
        }
        teams.push(team);
      });
      drivers = _.uniqBy(drivers, 'id');

      return objectAssign({}, state, {teams: teams, drivers: drivers, driversLocations: state.driversLocations.concat(driversLocations)});
    }      

    case types.ACTIVE_DRIVERS_FETCHED: {
      let locations = [];
      _.map(action.drivers, (driver) => {
        if(driver.driverGpsLocations)
          locations.push(driver.driverGpsLocations);
      });
      return objectAssign({}, state, {drivers: action.drivers, driversLocations: locations});
    }      

    case types.ACTIVE_DRIVERS_FOR_OPERATORS_FETCHED:
      var driversLocations = [];

      _.map(action.teams, (team) => {
        if(team.drivers) {
          _.map(team.drivers, (driver) => {
            if (driver.driverGpsLocations) {
              driversLocations.push(driver.driverGpsLocations)
            }
          });
        }
      });
      return objectAssign({}, state, { driversLocations });

    case GROUPAGE_ASSIGNED:
      return objectAssign({}, state, { groupageAssigned: action.groupageAssigned, groupage: action.groupage });

    case GROUPAGE_UNASSIGNED:
      return objectAssign({}, state, { groupageUnassigned: action.groupageUnassigned, loaded: action.loaded });

    case GROUPAGE_ASSIGN_FAILED:
      return state;

    case RESENT_SMS:
      return state;

    case MAP_MARKER_SHOW_INFO:
      newSetOfItemIdsWithShowInfo = new Set(state.setOfItemIdsWithShowInfo);
      newSetOfItemIdsWithShowInfo.add(action.itemId);
      return objectAssign({}, state, { setOfItemIdsWithShowInfo: newSetOfItemIdsWithShowInfo });

    case MAP_MARKER_HIDE_INFO:
      newSetOfItemIdsWithShowInfo = new Set(state.setOfItemIdsWithShowInfo);
      newSetOfItemIdsWithShowInfo.delete(action.itemId);
      return objectAssign({}, state, { setOfItemIdsWithShowInfo: newSetOfItemIdsWithShowInfo });

    case DATE_FILTER_SET:
      return objectAssign({}, state, { dateFilter: action.dateFilter });

    case GROUPAGE_CREATED:
      return objectAssign({}, state, { newGroupage: action.newGroupage, groupageCreated: action.groupageCreated, loaded: action.loaded });

    case GROUPAGE_DESTROYED:
      return objectAssign({}, state, { groupageDestroyed: action.groupageDestroyed, loaded: action.loaded });

    case ORDER_UPDATED:
      return objectAssign({}, state, { orderUpdated: action.orderUpdated, updatedOrder: action.updatedOrder });

    case ORDER_CANCELED:
      return objectAssign({}, state, { orderCanceled: action.orderCanceled });

    case ORDER_LIST_VIEW_MODE_CHANGED:
      return objectAssign({}, state, { orderListViewMode: action.orderListViewMode });

    case GROUPAGE_GPS_LOGS_FETCHED:
      return objectAssign({}, state, { gpsLogs: action.gpsLogs });
      
    case DISTANCE_ORDER_DRIVERS:
      return objectAssign({}, state, { orderDriversDistance: action.data });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dashboardPageReducer.js